export default __webpack_public_path__ + "static/media/hoseg2.5373e618.jpg";